// @flow

import { useContext } from 'react';
import { Context, ContextType } from '../contexts/createComponentReleaseContext';

const useCreateComponentReleaseContext: () => ContextType = () => useContext(Context);
export default useCreateComponentReleaseContext;
